import React from 'react';
import { Search, ShieldCheck, CalendarCheck, Heart } from 'lucide-react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    icon: Search,
    title: '浏览选择',
    subtitle: 'Browse & Select',
    desc: '浏览我们的精选伴游列表，根据您的喜好筛选地区、类型和价格。'
  }, {
    icon: ShieldCheck,
    title: '真人核验',
    subtitle: 'Verification',
    desc: '所有资料均经过人工审核，确保照片与本人一致，安全可靠。'
  }, {
    icon: CalendarCheck,
    title: '预约确认',
    subtitle: 'Book & Confirm',
    desc: '联系客服确认时间地点，支付定金锁定您的专属伴游。'
  }, {
    icon: Heart,
    title: '见面付款',
    subtitle: 'Meet & Pay',
    desc: '如约见面，满意后支付尾款，开启您的浪漫之旅。'
  }];
  return <section id="how-it-works" className="py-20 bg-dark-800 relative overflow-hidden" data-id="element-226">
      {/* Decorative Line */}
      <div className="absolute top-1/2 left-0 w-full h-px bg-white/5 hidden lg:block transform -translate-y-1/2" data-id="element-227"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-228">
        <div className="text-center mb-16" data-id="element-229">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-230">
            服务流程
          </h2>
          <p className="text-gray-400" data-id="element-231">简单四步，开启尊贵体验</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-232">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative group" data-id="element-233">
              <div className="bg-dark-900 border border-white/5 p-8 rounded-lg text-center hover:border-gold-500/30 transition-colors duration-300 h-full" data-id="element-234">
                <div className="w-16 h-16 mx-auto bg-dark-800 rounded-full flex items-center justify-center mb-6 border border-gold-500/20 group-hover:border-gold-500 group-hover:scale-110 transition-all duration-300 shadow-[0_0_15px_rgba(201,169,110,0.1)]" data-id="element-235">
                  <step.icon className="w-8 h-8 text-gold-500" data-id="element-236" />
                </div>

                <h3 className="text-xl font-bold text-white mb-1" data-id="element-237">
                  {step.title}
                </h3>
                <p className="text-xs text-gold-500 uppercase tracking-wider mb-4" data-id="element-238">
                  {step.subtitle}
                </p>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-239">
                  {step.desc}
                </p>

                {/* Step Number */}
                <div className="absolute top-4 right-4 text-4xl font-serif font-bold text-white/5 select-none" data-id="element-240">
                  0{index + 1}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}